class Modal extends HTMLElement {
  constructor() {
    super();

    this.triggers = document.querySelectorAll(".js-modal-trigger");
    this.modal = this.querySelector(".modal");
    this.close = this.querySelector(".modal__close");
    this.type = this.dataset.type;

    this.listeners();
  }

  listeners() {
    this.openModalEvent();

    if (this.type !== "age-gate") this.closeModalEvent();

    subscribe(PUB_SUB_EVENTS.modalOpen, ({ type }) => {
      if (this.type === type) this.openModal();
    });

    subscribe(PUB_SUB_EVENTS.modalClose, ({ type }) => {
      if (this.type === type) this.closeModal();
    });
  }

  openModalEvent() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener("click", () => {
        const dataset = trigger.dataset;

        if (this.type === dataset.type) this.openModal(trigger)
      });
    });
  }

  closeModalEvent() {
    this.close.addEventListener("click", () => this.closeModal());

    this.addEventListener("click", event => {
      if (event.target === this.modal) this.closeModal();
    });
  }

  openModal() {
    this.modal.classList.add("modal--active");

    document.body.classList.add('overflow-hidden');
  }

  closeModal() {
    this.modal.classList.remove("modal--active");

    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define("modal-component", Modal);
